export const bedActions = {
  SET_SICKBED: 'BED/SET_SICKBED',
};
